var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"ods-form",class:[
  _vm.labelPosition ? 'ods-form--label-' + _vm.labelPosition : '',
  { 'ods-form--inline': _vm.inline }
],attrs:{"data-name":"OdsForm"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }